'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useIsDarkMode } from '../hooks/use-is-darkmode.js';
const defaultModes = ['light', 'dark'];
/**
 * Provider for the mode
 * @example
 * ```ts
 * import { DarkModeProvider } from "@cloud/shared/ui"
 *
 * <DarkModeProvider>
 *   <App />
 * </DarkModeProvider>
 * ```
 */
export function DarkModeProvider({ children }) {
    const isDarkMode = useIsDarkMode();
    const mode = isDarkMode ? 'dark' : 'light';
    useEffect(() => {
        const rootElement = document.documentElement;
        // Update class names in the <html> tag
        rootElement.classList.remove(...defaultModes);
        rootElement.classList.add(mode);
    }, [mode]);
    return _jsx(_Fragment, { children: children });
}
